import React, { useMemo } from 'react';
import { isMobile } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { SHUFFLE_CARDS_COUNT } from '../../enums/constants';

function MobileCard({ cardBack }) {
  return (
    <div className='m-card-wrapper'>
      <div className='m-cards-holder'>
        <div className={`m-cards-item ${cardBack}`} />
      </div>
    </div>
  );
}

function WebCard({ cardBack }) {
  return (
    <div className='card-wrapper-s'>
      <div className='cards-holder-s'>
        <div className={`cards-item ${cardBack}`} />
      </div>
    </div>
  );
}

export const ShuffleCardsWrapper = observer(() => {
  const { selectedCardBackSideType, shuffleAnimationType, isShuffle } = cardsStore;
  const shuffleCards = useMemo(() => {
    const CardComp = isMobile() ? MobileCard : WebCard;
    return SHUFFLE_CARDS_COUNT.map((el) => (
      <CardComp cardBack={selectedCardBackSideType} key={el} />
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCardBackSideType, shuffleAnimationType]);

  if (!isShuffle) {
    return null;
  }

  return (
    <div
      className={`${isMobile() ? 'm-cards-wrp' : 'cards-wrp card-down'} ${shuffleAnimationType}`}
    >
      {shuffleAnimationType && shuffleCards}
    </div>
  );
});
